import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class WritingYes extends Component
{

    back(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    backwrtiting(){
        this.props.store.writingyes = "nothing";
        this.forceUpdate();
    }

    scene(){
        this.props.store.writingyes = "scene";
        this.forceUpdate();
    }

    scene1(){
        this.props.store.writingyes = "scene1";
        this.forceUpdate();
    }

    looks(){
        this.props.store.writingyes = "looks";
        this.forceUpdate();
    }

    looks1(){
        this.props.store.writingyes = "looks1";
        this.forceUpdate();
    }

    cloths(){
        this.props.store.writingyes = "cloths";
        this.forceUpdate();
    }

    cloths1(){
        this.props.store.writingyes = "cloths1";
        this.forceUpdate();
    }

    heart(){
        this.props.store.writingyes = "heart";
        this.forceUpdate();
    }

    heart1(){
        this.props.store.writingyes = "heart1";
        this.forceUpdate();
    }

    fight(){
        this.props.store.writingyes = "fight";
        this.forceUpdate();
    }

    figth1(){
        this.props.store.writingyes = "fight1";
        this.forceUpdate();
    }

    writingyes2(){
        this.props.store.writingyes = "writingyes2";
        this.forceUpdate();
    }

    writingyes3(){
        this.props.store.writingyes = "writingyes3";
        this.forceUpdate();
    }

    writingyes4(){
        this.props.store.writingyes = "writingyes4";
        this.forceUpdate();
    }
    
    render()
    {
        return <>
        
        {this.props.store.writingyes == "nothing" &&  <div className = "asktext">
        欢迎来到文笔指南~<br/><br/>
        文笔是最需要练习的部分<br/>
        在学技巧之前，就是大量了写作练习<br/><br/>

        请根据下面的专题，分别在每个专题下进行不少于三个的描写练习<br/>
        对于很多人来说，写不好只是因为没写过<br/>
        请准备好纸笔，或者能写作的电子设备<br/>
        直接开始吧
        
        
        
       <br/>
       <div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.scene() } >场景描写</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.looks() } >外貌描写</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.cloths() } >服饰描写</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.heart() } >心理描写</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.fight() } >战斗描写</Button><br/><br/>

        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.writingyes2() } >我已经都写好啦！</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >不，我要练情节或结构</Button><br/>
    </div>   
    </div> }

    {this.props.store.writingyes == "scene" &&  <div className = "asktext">
        欢迎来到场景练习。<br/><br/>
        请从下面几个场景中，选取场景，进行描写<br/>
        <br/>
        
        不用太苛责自己，尽力就好。<br/>

        <h3>场景1：大漠孤烟</h3>
        <h3>场景2：草原广袤</h3>
        <h3>场景3：高耸悬崖</h3>
        <h3>场景4：茂密森林</h3>
        <h3>场景5：深泽湖泊</h3>
        <br/>
        <h3>场景6：纷飞白雪</h3>
        <h3>场景7：樱花飘落</h3>
        <h3>场景8：星河灿烂</h3>
        <h3>场景9：大雨滂沱</h3>
        <h3>场景10：飞沙走石</h3>
        <br/>
        <h3>场景11：热闹街道</h3>
        <h3>场景12：华丽王宫</h3>
        <h3>场景13：废弃小巷</h3>
        <h3>场景14：断壁残垣</h3>
        <h3>场景15：血腥战场</h3>
        <br/>
        <h3>场景16：颠簸马车</h3>
        <h3>场景17：洗浴室内</h3>
        <h3>场景18：豪华餐厅</h3>
        <h3>场景19：服饰商店</h3>
        <h3>场景20：高档酒店</h3>
        
<br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.scene1() } >写好了</Button><br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >返回</Button><br/>
        </div>}

        {this.props.store.writingyes == "scene1" &&  <div className = "asktext">
            那再说一下写场景的小技巧吧<br/>
            <br/>
            场景描写包括了近景，远景，人物，声音，气味和触觉<br/>
            如果写得太单调，可以试着增加更多要素，让场景丰富起来<br/>
            <br/>
            描写的顺序有从整体到细节，先写整体，再刻画细节<br/>
            或者遵循人物的感官顺序，先看到的先写，后看到的后写<br/>
            或者从四周到中央，慢慢聚焦到最重要的景物身上<br/>
            有顺序的描写，就不会太过散乱<br/>
            <br/>
            可以根据这些简单的技巧去重写一下哦<br/><br/>
            写完之后，再练习一下其他的描写吧~<br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >去练习其他</Button><br/>
            </div>}


            {this.props.store.writingyes == "looks" &&  <div className = "asktext">
            欢迎来到外貌练习。<br/><br/>
        请从下面几个外貌中，选取外貌，进行描写<br/>
        <br/>
        
        不用太苛责自己，尽力就好。<br/>

        <h3>外貌1：邻家女孩</h3>
        <h3>外貌2：成熟御姐</h3>
        <h3>外貌3：高挑模特</h3>
        <h3>外貌4：混血公主</h3>
        <h3>外貌5：平凡少女</h3>
        <br/>
        <h3>外貌6：青涩少年</h3>
        <h3>外貌7：帅气男星</h3>
        <h3>外貌8：中年大叔</h3>
        <h3>外貌9：刀疤混混</h3>
        <h3>外貌10：普通青年</h3>
        <br/>
        <h3>外貌11：落魄乞丐</h3>
        <h3>外貌12：战场伤员</h3>
        <h3>外貌13：天生残疾</h3>
        <h3>外貌14：奇丑无比</h3>
        <h3>外貌15：监狱囚犯</h3>
        <br/>
        <h3>外貌16：传教牧师</h3>
        <h3>外貌17：医院护士</h3>
        <h3>外貌18：学堂教授</h3>
        <h3>外貌19：严肃警官</h3>
        <h3>外貌20：肃穆军人</h3>
        <br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.looks1() } >写好了</Button><br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >返回</Button><br/>

                
                </div>}

                {this.props.store.writingyes == "looks1" &&  <div className = "asktext">
                    那说一下外貌的小技巧吧<br/><br/>
                    外貌描写的要素有面容，身材，姿态和气质<br/>
                    面容是指脸长得怎么样<br/>
                    身材是指高矮胖瘦，身高腿长这些<br/>
                    姿态是指身体姿势，如含胸驼背，抬头挺胸等<br/>
                    气质是综合给人的感受，如气质优雅，端庄等<br/>
                    可以根据这些简单的技巧去重写一下哦<br/><br/>
                    写完之后，再练习一下其他的描写吧~<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >去练习其他</Button><br/>

                    </div>}


                    {this.props.store.writingyes == "cloths" &&  <div className = "asktext">
                    欢迎来到服饰练习。<br/><br/>
                    请从下面几个服饰中，选取服饰，进行描写<br/>
                     <br/>
        
                    不用太苛责自己，尽力就好。<br/>

                    <h3>服饰1：学生校服</h3>
                    <h3>服饰2：军队制服</h3>
                    <h3>服饰3：医院制服</h3>
                    <h3>服饰4：警官制服</h3>
                    <h3>服饰5：日常装扮</h3>
                    <br/>
                    <h3>服饰6：职业正装</h3>
                    <h3>服饰7：西装革履</h3>
                    <h3>服饰8：清纯长裙</h3>
                    <h3>服饰9：帅气套装</h3>
                    <h3>服饰10：俏皮短裙</h3>
                    <br/>
                    <h3>服饰11：古装汉服</h3>
                    <h3>服饰12：葬礼丧服</h3>
                    <h3>服饰13：洁白婚纱</h3>
                    <h3>服饰14：华丽礼服</h3>
                    <h3>服饰15：民族服饰</h3>
                    <br/>
                    <h3>服饰16：邋遢肮脏</h3>
                    <h3>服饰17：寒酸破旧</h3>
                    <h3>服饰18：潮流服饰</h3>
                    <h3>服饰19：别扭装扮</h3>
                    <h3>服饰20：金玉其外</h3>
                    <br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.cloths1() } >写好了</Button><br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >返回</Button><br/>
                        </div>}

                        {this.props.store.writingyes == "cloths1" &&  <div className = "asktext">
                        来说一下服饰的小技巧吧<br/><br/>
                        服饰是装饰人体的物品总称，指衣着和装饰。<br/>
                        所以除了衣服裤子之外，还包括了帽子，鞋袜，背包<br/>
                        包括了配件，如披风，围巾，领带，手套，雨伞，腰带，折扇<br/>
                        还有首饰如王冠，项链，手链，玉坠等等<br/>
                        <br/><br/>
                        对于每一个部件，可以描写的要素有色彩，质地，样式和穿着效果<br/>
                        如果写得太单调，可以试着增加更多要素，让服饰丰富起来<br/><br/>
                        除此之外，如果想描写现代，都市背景的服饰<br/>
                        可以使用购物软件，把关键词打进去可以获得一些描写信息的提示<br/><br/>
                    写完之后，再练习一下其他的描写吧~<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >去练习其他</Button><br/>
                            </div>}

                            {this.props.store.writingyes == "heart" &&  <div className = "asktext">
                            欢迎来到心理描写练习。<br/><br/>
                            请从下面几个心理中，选取情绪，进行描写<br/>
                            <br/>
        
                            不用太苛责自己，尽力就好。<br/>

                            <h3>情绪1：开心愉悦</h3>
                            <h3>情绪2：悲伤哀痛</h3>
                            <h3>情绪3：愤怒生气</h3>
                            <h3>情绪4：恐惧害怕</h3>
                            <h3>情绪5：厌恶恶心</h3>
                            <br/>
                            <h3>情绪6：惊讶意外</h3>
                            <h3>情绪7：百无聊赖</h3>
                            <h3>情绪8：消沉失落</h3>
                            <h3>情绪9：纠结困扰</h3>
                            <h3>情绪10：兴奋期待</h3>
                            <br/>
                            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.heart1() } >写好了</Button><br/>
                            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >返回</Button><br/>
                                </div>}


                                {this.props.store.writingyes == "heart1" &&  <div className = "asktext">
                                那说一下心理描写的小技巧吧<br/>
                                心理描写最外层是动作，表情和状态。如皱眉，发抖，大笑，晕倒等等，是外界能看出来的<br/>
                                第二层是人物的感受，外界看不出来，是主观的感受。比如胸口一痛，眼前一黑<br/>
                                第三层是内心独白，用话语的方式写出角色的想法<br/>
                                最后一层是概念，可能连角色本身都没有意识到他的心理活动实际上是什么<br/>
                                但是作者知道，可以写他爱慕虚荣，向往繁华的生活但又不愿意承担责任等等。<br/>
                                <br/>
                                不同的层次混合着进行心理描写，就能更好的表现人物内心。<br/>
                                可以试一试哦~<br/>
                                写完之后，再练习一下其他的描写吧~<br/><br/>
                                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >去练习其他</Button><br/>
                                 </div>}


                                 {this.props.store.writingyes == "fight" &&  <div className = "asktext">
                                 欢迎来到战斗练习。<br/><br/>
                                请从下面几个战斗中，选取战斗状况，进行描写<br/>
                                <br/>
                                <h3>战斗1：大获全胜</h3>
                                <h3>战斗2：一败涂地</h3>
                                <h3>战斗3：势均力敌</h3>
                                <h3>战斗4：偷袭成功</h3>
                                <h3>战斗5：且战且退</h3>
                                <br/>
                                <h3>战斗6：越战越勇</h3>
                                <h3>战斗7：点到为止</h3>
                                <h3>战斗8：聚众群殴</h3>
                                <h3>战斗9：师徒教学</h3>
                                <h3>战斗10：打车轮战</h3>
                                <br/><br/>
                                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.figth1() } >写好了</Button><br/>
                            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >返回</Button><br/>
                                     </div>}

                                     {this.props.store.writingyes == "fight1" &&  <div className = "asktext">
                                         那来说一下战斗的小技巧吧<br/><br/>
                                         大家的战斗词汇一般比较缺乏，于是先来给一些动词<br/>
                                         腾、跃、扑、袭、挑、砍、劈、切、抓、扯、绊、引、截、踢、刺、压、弹、锁、转、缠、扣、扫、擒、拿、封、扭、震<br/>
                                         一些部位<br/>
                                         眉心、四肢百骸、周身大穴、咽喉、后天、天灵盖<br/>
                                         一些动态描写<br/>
                                         腾空而起、一叶渡江、凌空飞渡、纵身上跃、矫若游龙、欺身而进、大鹏展翅、忽快忽慢、犹如鬼魅、跃前纵后、快不及眼、骤然而至、兔起鹘落、捷若雄鹰、惊鸿照影、翩若惊鸿、电光火石、虚实莫测、进退迅疾<br/>
                                         这就是非常随意的词汇参考，大家也就随意看看<br/><br/>
                                         战斗描写的三要素是氛围，解说和打斗。<br/>
                                         氛围包括双方的心理状态，观众的反应<br/>
                                         解说包括招式的背景，厉害程度的讲解等<br/>
                                         打斗才是对声音，动作分解，战斗效果的描写<br/><br/>
                                         如果写得太单调，可以试着增加更多要素，让战斗丰富起来<br/><br/>
                                        写完之后，再练习一下其他的描写吧~<br/><br/>
                                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backwrtiting() } >去练习其他</Button><br/>

                                         </div>}

                                         {this.props.store.writingyes == "writingyes2" &&  <div className = "asktext">
                                             除了练习之外，当然还有其他的提升方式<br/>
                                             那就是摘抄和仿写！<br/><br/>
                                             我们先来说摘抄<br/>
                                             请找一个本子，分类为场景，外貌，服饰，心理，战斗和其他<br/>
                                             然后在看小说时，遇到觉得写得好，而且自己写不出来的<br/>
                                             就拿出小本本，把它摘抄下来<br/>
                                             记得标记一下小说名称和章节以便查找<br/>
                                             最后再笼统的概括一下，这写了些什么<br/><br/>
                                             现在就先去摘抄看看吧~<br/>
                                             如果对自己的文笔不满意，请至少保持一周两三篇的摘抄量<br/><br/>
                                             <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.writingyes3() } >好的！我摘抄完了</Button><br/>
                                             
                                             </div>}

                                             {this.props.store.writingyes == "writingyes3" &&  <div className = "asktext">
                                                 接下来，我们来试试仿写。<br/>
                                                 摘抄完毕之后，先把文段放一天<br/>
                                                 第二天，再试着根据摘抄的概括，自己写一下<br/>
                                                 再和原文段进行对比，看看哪个更好，为什么更好。<br/><br/>
                                                 如果对自己的文笔不满意，请至少保持一周两三篇的仿写<br/><br/>
                                                 <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.writingyes4() } >好的！我知道啦！</Button><br/>
                                                 </div>}

                                                 {this.props.store.writingyes == "writingyes4" &&  <div className = "asktext">
                                                     <br/>太好啦！你已经完成文笔篇的指南啦<br/><br/>
                                                     只要多练习，文笔就会有明显的进步的<br/>
                                                     希望你早日写出令自己满意的文字<br/><br/>
                                                     如果还有其他想提升的，请点击返回按钮<br/><br/>
                                                     <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >返回</Button><br/>
                                                     </div>}


        
   
        </>;
    }
} 